function targetDuration(str) {
  return parseInt(str) || -1;
}

module.exports = targetDuration;
